import { styled } from 'dripsy';
import React from 'react';
import { View } from 'react-native';

import { Loader } from '../common/Loader';

const Container = styled(View)({
  py: '$8',
  px: '$8',
  bg: '$background0',
  borderRadius: 8,
  size: 72,
  alignItems: 'center',
  justifyContent: 'center',
});

export function LoaderModal() {
  return (
    <Container>
      <Loader size="large" />
    </Container>
  );
}
